const SIZES = {
  xs: 'h-3 w-3 border-2',
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-[3px]',
  lg: 'h-10 w-10 border-4',
};

export default function Loader({ size = 'md', className = '' }) {
  const sz = SIZES[size] || SIZES.md;
  return (
    <span
      role="status"
      aria-label="Loading"
      className={`inline-block animate-spin rounded-full border-current border-t-transparent opacity-90 ${sz} ${className}`}
    />
  );
}

export function Skeleton({ className = '', rounded = 'rounded' }) {
  return <div className={`skeleton ${rounded} ${className}`} />;
}
